import AsyncSelect, { Option, type AsyncSelectBaseProps } from "./AsyncSelect";
import { useTranslation } from "react-i18next";
import { forwardRef } from "react";
import { EntityListLink } from "./EntityListLink";
import { fetchStoreFormatList } from "@/services/storeFormat";
import { Module, PATH_DICTS_STORE_FORMATS } from "@/constants";
import appConfiguration from "./cfg/AppCfg";

interface StoreFormatSelectProps extends AsyncSelectBaseProps {
  className?: string;
  defaultItem?: Partial<Option>;
}

export default forwardRef<HTMLButtonElement, StoreFormatSelectProps>(
  function StoreFormatSelect({ value, defaultItem, ...props }, ref) {
    const { t } = useTranslation();

    return (
      <span className="flex items-center gap-1">
        <AsyncSelect
          queryKey={[Module.StoreFormats]}
          queryFn={() =>
            fetchStoreFormatList({
              limit: appConfiguration.selectComponentsPaginationLimit,
            })
          }
          placeholder={t("storeFormatSelect.placeholder")}
          loadingLabel={t("storeFormatSelect.loadingStoreFormats")}
          {...props}
          value={value ? value.toString() : undefined}
          ref={ref}
          enableFilter={false}
          defaultItem={defaultItem}
        />
        <EntityListLink
          path={PATH_DICTS_STORE_FORMATS}
          label={t("storeFormatSelect.link")}
        />
      </span>
    );
  },
);
